import PropTypes from "prop-types";
import { cn } from "@/lib/utils";

export function PageHeader({ title, description, actions, breadcrumbs, className }) {
  return (
    <div className={cn("flex flex-col gap-2 px-4 sm:px-6 pt-5 sm:pt-6 pb-4 border-b border-slate-200 bg-white min-w-0", className)}>
      {breadcrumbs && (
        <nav className="flex items-center gap-1.5 text-xs text-slate-500 overflow-x-auto scrollbar-thin" data-testid="page-breadcrumbs">
          {breadcrumbs.map((b, i) => (
            <span key={b} className="inline-flex items-center gap-1.5 shrink-0">
              {i > 0 && <span className="text-slate-300">/</span>}
              <span className={i === breadcrumbs.length - 1 ? "text-slate-700 font-medium" : ""}>
                {b}
              </span>
            </span>
          ))}
        </nav>
      )}
      <div className="flex flex-col gap-3 sm:flex-row sm:items-start sm:justify-between sm:gap-4 min-w-0">
        <div className="min-w-0">
          <h1 className="text-lg sm:text-xl font-semibold tracking-tight text-slate-900" data-testid="page-title">
            {title}
          </h1>
          {description && (
            <p className="mt-1 text-sm text-slate-500 max-w-2xl">{description}</p>
          )}
        </div>
        {actions && <div className="flex flex-wrap items-center gap-2 shrink-0">{actions}</div>}
      </div>
    </div>
  );
}

PageHeader.propTypes = {
  title: PropTypes.string.isRequired,
  description: PropTypes.string,
  actions: PropTypes.node,
  breadcrumbs: PropTypes.arrayOf(PropTypes.string),
  className: PropTypes.string,
};
